export default {
  brand: {
    name: 'USFansLink',
    tagline: 'Centro de recursos del spreadsheet',
  },
  nav: {
    home: 'Inicio',
    shoppingGuide: 'Guía de compras',
    articles: 'Artículos',
    qc: 'Guía QC',
    shipping: 'Envío',
    faq: 'FAQ',
    browse: 'Explorar categorías',
  },
  buttons: {
    buyNow: 'Comprar ahora',
    explore: 'Explorar el spreadsheet de USFans',
    browseGuides: 'Ver guías de productos',
    readMore: 'Leer la guía',
    backHome: 'Volver al inicio',
    viewAll: 'Ver todas las categorías',
    continue: 'Ir al sitio web principal',
  },
  footer: {
    about: 'USFansLink.site es un recurso informativo independiente sobre el spreadsheet de USFans. Ayudamos a los compradores a encontrar enlaces de productos, información QC, guías de envío y consejos de compra seguros.',
    quickLinks: 'Enlaces rápidos',
    categories: 'Categorías',
    resources: 'Recursos',
    language: 'Idioma',
    disclaimer: 'Aviso: los enlaces externos, productos, precios, información de envío y promociones pueden cambiar. Verifica siempre la información actual antes de comprar o pagar.',
    copyright: 'Todos los derechos reservados.',
  },
};